import Notifier from "./Notifier.presenter";

export default Notifier;
